import { Media } from "react-bootstrap";
import { BASE_URL } from "../../helper/constants";
import UserAvatar from "../../components/UserAvatar";
import { Skeleton } from "@material-ui/lab";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import React, { useEffect, useState } from "react";
import LanguageContext from "../../helper/LanguageContext";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { callAPI } from "../../helper/apiUtils";
import { requestDirectMessage } from "../../helper/directMessagePrompt";
import { useSelector } from "react-redux";
import { ReactComponent as SmilyIcon } from "../../Icons/SmilyDeselected.svg";
import LikesDropdown from "../../components/LikesDropdown";
import {
  convertBranchRole,
  convertHtmlString,
  tempFunction,
} from "../../helper/convertor";
import PlayerFeed from "../../components/PlayerFeed";
import ReadMoreReact from "read-more-react";
import ReadMores from "../../components/ReadMores";
import { FaThumbtack } from "react-icons/fa";
import MaterialIcon from "../../components/MaterialIcon";
import ArticleAdminMenu from "../../components/ArticleAdminMenu";
import { stripMarkdownFromTitle } from "../../helper/stripMarkdownTitle";
import { HighlightText } from "../../helper/highlightSearch";
import "./UserFeed.css";
const extractUrls = require("extract-urls");

export function UserFeed({
  article,
  index,
  expandArticle,
  reloadArticle,
  viewArticleDetail,
  handleLike,
  isDetails = false,
  isInternal = false,
  canPinArticle = false,
  onTogglePin,
  isPinned = false,
  pinLoading = false,
  searchQuery = "",
  canManageArticle = false,
  onEditArticle,
  onDeleteArticle,
}) {
  const { isGerm, strings } = React.useContext(LanguageContext);
  const [likeStatus, setLikeStatus] = useState(false);
  const [_Link, _setLink] = useState([]);
  const [likeHover, setLikeHover] = useState(false);
  const user = useSelector((state) => state.user);
  const likeArticle = async (article) => {
    setLikeStatus(true);
    if (user?.id !== article.postedById) {
      handleLike(article.id);
      try {
        await callAPI(
          `/article/${article.id}/like`,
          { id: article.id, emoji: 6, lang: "en" },
          "GET"
        );
      } catch (err) {
        handleLike(article.id);
      }
    }
    setTimeout(() => setLikeStatus(false), 1300);
  };
  const getProfile = (postedById) => {
    if (!postedById) return;
    requestDirectMessage({
      id: postedById,
      fullName: article.postedByName || article.fullName || `${article.firstName || ""} ${article.lastName || ""}`.trim(),
      avatar: article.avatar || article.postedByAvatar || article.postedByImage,
    });
  };

  const viewFullScreen = async () => {
    viewArticleDetail(article);
  };
  const [articleBranch, setArticleBranch] = React.useState([]);
  React.useEffect(() => {
    let tempRole = article.buildingIndustryRole?.split(",");
    let temoVal = tempRole?.map(
      (itm, index) => (index ? ", " : "") + convertBranchRole(itm, isGerm)
    );
    setArticleBranch(temoVal);
  }, [article]);

  useEffect(() => {
    if (article?.description && typeof article?.description === "string") {
      let dec = article?.description;
      let datax = extractUrls(dec);
      datax =
        datax && Array.isArray(datax)
          ? datax.map((e) => {
              return e.replace("&quot", "");
            })
          : datax;
      let data = [...new Set(datax)];
      let all = [];
      console.log("here", data);
      if (data && data.length > 0) {
        for (let obj of data) {
          let x = {
            href: obj,
          };
          let lnk = obj;
          if (lnk.match("vimeo")) {
            x.videoType = "vimeo";
            all.push(x);
          }
          if (lnk.match("youtube") || lnk.match("youtu")) {
            x.videoType = "youtube";
            all.push(x);
          }
        }
        if (all.length > 0) {
          if (article.uploadUrl && article.uploadUrl.length > 0)
            _setLink([...all, ...article.uploadUrl]);
          else _setLink([...all]);
        } else if (article.uploadUrl && article.uploadUrl.length > 0) {
          _setLink([...article.uploadUrl]);
        }
      } else {
        if (article.uploadUrl && article.uploadUrl.length > 0) {
          _setLink([...article.uploadUrl]);
        }
      }
    } else if (article.uploadUrl && article.uploadUrl.length > 0) {
      _setLink([...article.uploadUrl]);
    }
  }, [article]);
  const pinButtonTitle = isPinned
    ? (strings.unpin_article)
    : (strings.pin_article);
  const handlePinClick = () => {
    if (pinLoading) {
      return;
    }
    if (onTogglePin) {
      onTogglePin();
    }
  };

  const showPinButton = isInternal && canPinArticle;
  const showAdminActions = canManageArticle || showPinButton;

  return (
    <div className={`feed-details${showAdminActions ? ' has-admin-actions' : ''}${showPinButton ? ' has-pin' : ''}${canManageArticle ? ' has-manage-menu' : ''}`}>
      {showAdminActions && (
        <div className="article-admin-actions">
          {canManageArticle && onEditArticle && onDeleteArticle && (
            <ArticleAdminMenu
              onEdit={onEditArticle}
              onDelete={onDeleteArticle}
            />
          )}
          {showPinButton && (
            <button
              type="button"
              className={`kj-btn kj-btn--icon kj-btn--lg kj-btn--neutral kj-btn--internal article-pin-btn ${isPinned ? 'pinned' : ''} ${pinLoading ? 'loading' : ''}`}
              onClick={handlePinClick}
              disabled={pinLoading}
              aria-pressed={isPinned}
              aria-label={pinButtonTitle}
              title={pinButtonTitle}
            >
              <FaThumbtack
                size={16}
                className="article-pin-icon"
              />
            </button>
          )}
        </div>
      )}
      <Media>
        {article.avatar && (
          <UserAvatar
            width={40}
            height={40}
            className="mr-3 news_profile"
            src={
              article.avatar
                ? BASE_URL + article.avatar
                : process.env.PUBLIC_URL + "assets/img/profile.png"
            }
            alt="User avatar"
            fallbackSrc={process.env.PUBLIC_URL + "assets/img/profile.png"}
          />
        )}
        {!article.avatar && (
          <div className="svg_icon mr-3 news_profile">
            <svg width="50px" height="50px" viewBox="0 0 99.84 99.83">
              <path
                className="prf1"
                d="M318.68,147.82l2.2-2.17c-6.17-2.82-12.74-4.33-15.94-5.74S293,134.24,293,134.24s-.42-6.86-3-7.26l.43-4.64s3-6.45,3-10.48c0,0,3,2.42,4.05-3s2.56-15.51-2.13-13.1c0,0,1-8,.11-12.89s-5.22-19.74-24.82-19.74-24,14.91-24.81,19.74.1,12.89.1,12.89c-4.68-2.41-3.19,7.66-2.13,13.1s4,3,4,3c0,4,3,10.48,3,10.48l.43,4.64c-2.56.4-3,7.26-3,7.26s-8.72,4.26-11.92,5.67c-2.76,1.22-3.54,3.29-9.82,6.16a13.32,13.32,0,0,0,6.9,4.52,16.83,16.83,0,0,0,4.41.6h34l36.59-.22c1.8,0,5.46-.25,7.59-1.24.33-.21,2.27-1.67,2.58-1.91"
                transform="translate(-223.59 -52.87)"
              />
              <rect
                className="prf2"
                x="1.5"
                y="1.5"
                width="96.84"
                height="96.83"
                rx="10.49"
                ry="10.49"
              />
            </svg>
          </div>
        )}
        <Media.Body>
          <div className="w-100 authore_name">
            {article.userFullName ? (
              <h5
                className="user-feed__author"
                onClick={(e) => getProfile(article.postedById, article.id)}
              >
                {article.userFullName ? (
                  article.userFullName
                ) : (
                  <Skeleton variant="text" />
                )}
                {article.id ? (
                  <span className="user_position">
                    {" "}
                    | {article.buildingIndustryRole ? articleBranch : ""}
                  </span>
                ) : (
                  <Skeleton variant="text" />
                )}
              </h5>
            ) : (
              <Skeleton variant="text" />
            )}
          </div>
          <div className="w-100">
            {article.product ? (
              <h6 className="product_user">
                {strings.product_label} <span>{article.product}</span>
              </h6>
            ) : (
              ""
            )}
          </div>
        </Media.Body>
      </Media>
      {isInternal && article.deptLocation && Array.isArray(article.deptLocation) && article.deptLocation.filter(d => d && d.departmentLocation).length > 0 && (
        <div className="article-dept-location-tabs">
          {article.deptLocation.filter(d => d && d.departmentLocation).map((dept, i) => (
            <span key={dept.deptLocation || i} className="article-dept-location-tab">
              {dept.departmentLocation}
            </span>
          ))}
        </div>
      )}
      <p className="m-0 mt-2 mb-2">
        <Link
          to={`/feed-detail/${article.id}`}
          className="font-weight-bold article-title-markdown user-feed__title-link"
        >
          <HighlightText text={stripMarkdownFromTitle(article.title || '')} query={searchQuery} />
        </Link>
      </p>
      <div className="small user-feed__desc">
        <ReadMores searchQuery={searchQuery}>{article?.description}</ReadMores>
      </div>
      {/* {_Link && _Link.length > 0 && */}
      <PlayerFeed Links={_Link} article={article} viewArticleDetail={viewArticleDetail} isInternal={isInternal} />
      {/* } */}
      <div className="date-follow">
        <p>{new Date(article.createdAt).toLocaleDateString(isGerm ? 'de-DE' : 'en-GB', {
          day: 'numeric',
          month: 'long'
        })}, {new Date(article.createdAt).toLocaleTimeString(isGerm ? 'de-DE' : 'en-US', {
          hour: '2-digit',
          minute: '2-digit'
        })}</p>
        {article.likeCount > 0 && (
          <LikesDropdown 
            articleId={article.id} 
            likes={article.likes} 
            likeCount={article.likeCount}
            isInternal={isInternal}
            
          >
            <div 
              className="follow-img user-feed__likes"
            >
              <div className="likes-avatar-container">
                {(() => {
                  const getLikeAvatarUrl = (likeUser) => {
                    const avatar = likeUser?.avatar || likeUser?.userAvatar || likeUser?.userImage || likeUser?.userProfileImage || likeUser?.postedByImage || likeUser?.profileImage;
                    if (!avatar) return null;
                    if (typeof avatar === 'string' && (avatar.startsWith('http://') || avatar.startsWith('https://'))) return avatar;
                    return BASE_URL + avatar;
                  };
                  const likesArray = !article.likes ? [] : (Array.isArray(article.likes) ? article.likes : [article.likes]).filter(Boolean);
                  return likesArray.slice(0, Math.min(3, likesArray.length)).map((like, i) => (
                    <img
                      key={like?.id || `like-${i}`}
                      src={getLikeAvatarUrl(like) || process.env.PUBLIC_URL + "/assets/img/profile.png"}
                      alt={like?.userFullName || like?.fullName || like?.name || "User"}
                      className={`like-avatar-enter user-feed__like-avatar${i > 0 ? " user-feed__like-avatar--stacked" : ""}${like?.isKjuup ? " user-feed__like-avatar--internal" : ""}`}
                      style={{ '--user-feed-like-z': 3 - i }}
                      onError={e => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/assets/img/profile.png"; }}
                    />
                  ));
                })()}
              </div>

              <span className="like-count-transition user-feed__like-count">
                {(() => {
                  const likesArray = !article.likes ? [] : (Array.isArray(article.likes) ? article.likes : [article.likes]).filter(Boolean);
                  const firstLike = likesArray[0];
                  const userName = firstLike?.userFullName || firstLike?.fullName || firstLike?.name ||
                    (firstLike?.firstName && firstLike?.lastName ? `${String(firstLike.firstName).trim()} ${String(firstLike.lastName).trim()}` : null);
                  if (userName && article.likeCount > 0) {
                    if (article.likeCount === 1) {
                      return userName;
                    } else {
                      return `${userName} ${strings.and} ${article.likeCount - 1} ${strings.others}`;
                    }
                  }
                  
                  return `${article.likeCount}`;
                })()}
              </span>
            </div>
          </LikesDropdown>
        )}
        {article.isEmojiUsed && (
          <SmilyIcon width={20} className="smily-icon active float-right" />
        )}
      </div>
      <div
        className={
          user?.id === article.postedById
            ? `date-follow ${isInternal ? 'no-border-internal' : 'no-border'} like_folo no-hover-effect`
            : `date-follow ${isInternal ? 'no-border-internal' : 'no-border'}`
        }
      >
        <a
          onClick={(e) => {
            likeArticle(article);
          }}
          onMouseEnter={() => user?.id !== article.postedById && setLikeHover(true)}
          onMouseLeave={() => setLikeHover(false)}
          className={`date-follow-link ${user?.id === article.postedById ? 'date-follow-link-deactivated' : 'pointer'} ${
            article.likeStatus ? "social-icon-active" : ""
          } ${
            likeStatus && user?.id !== article.postedById
              ? "bouncing-animation"
              : ""
          } user-feed__like-link${likeHover ? ` user-feed__like-link--hover${isInternal ? ' user-feed__like-link--internal' : ''}` : ''}`}
        >
          <MaterialIcon
            icon="thumb_up"
            size={24}
            weight={300}
            fill={article.likeStatus ? 1 : 0}
            color={user?.id === article.postedById
              ? '#e0e0e0'
              : likeHover
                ? (isInternal ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)')
                : article.likeStatus
                  ? (isInternal ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)')
                  : '#737373'}
            className="mr-1 user-feed__like-icon"
          />
          <span
            className={`date-follow-label user-feed__like-label${user?.id === article.postedById ? '' : (likeHover || article.likeStatus) ? ` user-feed__like-label--active${isInternal ? ' user-feed__like-label--internal' : ''}` : ' user-feed__like-label--idle'}`}
          >
            {strings.like}
          </span>
        </a>
      </div>
    </div>
  );
}
